import React, { useEffect } from "react";

const Modal = ({ isOpen, closeModal, title, children }) => {
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (isOpen && !e.target.closest(".modal-content")) {
                closeModal();
            }
        };
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, [isOpen, closeModal]);

    if (!isOpen) return null;

    return (
        <div className="modal fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 z-50">
            <div className="modal-content relative bg-white p-6 rounded-xl">
                <h2 className="text-lg font-semibold">{title}</h2>
                <div className="mt-4">{children}</div>
                <button onClick={closeModal} className="absolute top-2 right-2 text-xl">&times;</button>
            </div>
        </div>
    );
};

export default Modal;
